// Abre uma conexão só para criar a sala (ou pedir a do jogo de campeonato); a sala de espera abre a conexão dela.
import { config } from '../comum/config.ts';
import type { PerfilConta, Sessao } from '../comum/conta.ts';
import { ConexaoMesa, type NovaSala } from './conexao.ts';

export function criarSala(s: Sessao, p: PerfilConta, nova: NovaSala = {}): Promise<string> {
  return comConexao(s, p, (c) => c.criarSala(nova));
}

// A sala do jogo de campeonato (o mesmo código para os 6).
export function salaDoCampeonato(s: Sessao, p: PerfilConta, jogo: string): Promise<string> {
  return comConexao(s, p, (c) => c.salaDoCampeonato(jogo));
}

async function comConexao(s: Sessao, p: PerfilConta, fazer: (c: ConexaoMesa) => Promise<string>): Promise<string> {
  const c = new ConexaoMesa(config.mesaUrl, () => s.token(), { apelido: p.apelido, avatar: p.avatar }, null).iniciar();
  try {
    await new Promise<void>((ok, falha) => {
      const prazo = setTimeout(() => { tirar(); falha(new Error('A mesa não respondeu. Tente de novo.')); }, 10_000);
      const ver = () => {
        const e = c.obter();
        if (e.status === 'aberta') { clearTimeout(prazo); tirar(); ok(); }
        else if (e.erro) { clearTimeout(prazo); tirar(); falha(new Error(e.erro.mensagem)); }
      };
      const tirar = c.assinar(ver);
      ver();
    });
    return await fazer(c);
  } finally { c.encerrar(); }
}
